import { Component, Inject, OnInit } from '@angular/core';
import { VNG_DIALOG_DATA, VngDialogRef } from '@vengreso/angular-components';

@Component({
    selector: 'app-sign-in-error',
    templateUrl: './sign-in-error.component.html',
    styleUrls: ['./sign-in-error.component.scss'],
    standalone: false
})
export class SignInErrorComponent implements OnInit {
  adminEmail: string;
  supportEmail: string = 'heysupport@vengreso.com';

  constructor(
    public dialogRef: VngDialogRef<SignInErrorComponent>,
    @Inject(VNG_DIALOG_DATA) public data: any,
  ) 
  { 
    this.adminEmail = data?.admin_email;
  }

  ngOnInit(): void {
  }

  close(){
    this.dialogRef.close();
  }
}
